import * as actionTypes from "../../../../actionTypes";
import * as api from "../../../../../api/index";
// import { toast } from 'react-toastify';


export const GetClassesMappingBIZaccountingTPIQBD = (page, limit, query, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getClassesMappingBIZaccountingTPIQBD(page, limit, query);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_CLASSES_MAPPING_BIZ_ACCTPI_QBD, payload: data.data });
    }else{
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};

export const GetAccountsMappingBIZaccountingTPIQBD = (page, limit, query, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getAccountsMappingBIZaccountingTPIQBD(page, limit, query);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_ACCOUNTS_MAPPING_BIZ_ACCTPI_QBD, payload: data.data });
    }else{
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};

export const GetSalesTaxesMappingBIZaccountingTPIQBD = (page, limit, query, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getSalesTaxesMappingBIZaccountingTPIQBD(page, limit, query);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_SALES_MAPPING_TAXES_BIZ_ACCTPI_QBD, payload: data.data });
    }else{
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};

export const GetItemsMappingnBIZaccountingTPIQBD = (page, limit, query, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getItemsMappingnBIZaccountingTPIQBD(page, limit, query);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_ITEMS_MAPPING_BIZ_ACCTPI_QBD, payload: data.data });
    }else{
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};

export const GetVendorsMappingnBIZaccountingTPIQBD = (page, limit, query, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getVendorsMappingnBIZaccountingTPIQBD(page, limit, query);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_VENDORS_MAPPING_BIZ_ACCTPI_QBD, payload: data.data });
    }else{
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};

export const GetCustomersMappingnBIZaccountingTPIQBD = (page, limit, query, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getCustomersMappingnBIZaccountingTPIQBD(page, limit, query);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_CUSTOMERS_MAPPING_BIZ_ACCTPI_QBD, payload: data.data });
    }else{
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};

export const GetBillsMappingnBIZaccountingTPIQBD = (page, limit, query, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getBillsMappingnBIZaccountingTPIQBD(page, limit, query);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_BILLS_MAPPING_BIZ_ACCTPI_QBD, payload: data.data });
    }else{
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};

export const GetBillPaymentsMappingnBIZaccountingTPIQBD = (page, limit, query, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getBillPaymentsMappingnBIZaccountingTPIQBD(page, limit, query);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_BILL_PAYMENTS_MAPPING_BIZ_ACCTPI_QBD, payload: data.data });
    }else{
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};

export const GetInvoicesMappingnBIZaccountingTPIQBD = (page, limit, query, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getInvoicesMappingnBIZaccountingTPIQBD(page, limit, query);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_INVOICES_MAPPING_BIZ_ACCTPI_QBD, payload: data.data });
    }else{
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};

export const GetInvoicePaymentsMappingnBIZaccountingTPIQBD = (page, limit, query, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getInvoicePaymentsMappingnBIZaccountingTPIQBD(page, limit, query);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_INVOICE_PAYMENTS_MAPPING_BIZ_ACCTPI_QBD, payload: data.data });
    }else{
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};

export const GetJournalEntriesMappingnBIZaccountingTPIQBD = (page, limit, query, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getJournalEntriesMappingnBIZaccountingTPIQBD(page, limit, query);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_JOURNAL_ENTRIES_MAPPING_BIZ_ACCTPI_QBD, payload: data.data });
    }else{
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};

export const GetChecksMappingnBIZaccountingTPIQBD = (page, limit, query, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getChecksMappingnBIZaccountingTPIQBD(page, limit, query);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_CHECKS_MAPPING_BIZ_ACCTPI_QBD, payload: data.data });
    }else{
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};